// @ts-strict-ignore
import {ChangeDetectorRef, Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, output} from "@angular/core";
import {Icon, Markerset, ScenarioRecording, ScenarioRecordingState} from "@models";
import {animate, style, transition, trigger} from "@angular/animations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import Enumerable from "linq";
import {SimMarkersetService, NotificationService, SimUtilityService, TrackByMethods} from "@services";
import {parseInt} from "lodash-es";
import {TranslateService} from "@ngx-translate/core";
import {ICONS_WITHOUT_FILTER} from "../bookmark-pane/bookmark-pane-normal/bookmark-pane.component";
import {Translations} from "@translations";

@Component({
	selector: "sim-marker-set-pane",
	templateUrl: "./marker-set-pane.component.html",
	styleUrls: ["./marker-set-pane.component.scss"],
	animations: [
		trigger("fadeIn", [
			transition(":enter", [
				style({
					opacity: "0",
					height: "0px",
				}),
				animate(
					".175s ease-out",
					style({
						opacity: "1",
						height: "75px",
					}),
				),
			]),
		]),
		trigger("fadeOut", [
			transition(":leave", [
				style({
					opacity: "1",
					height: "75px",
				}),
				animate(
					".175s ease-out",
					style({
						opacity: "0",
						height: "0px",
					}),
				),
			]),
		]),
		zoomInOnEnterAnimation({duration: 175}),
		zoomOutOnLeaveAnimation({duration: 175}),
	],
	standalone: false,
})
export class MarkerSetPaneComponent implements OnInit, OnChanges {
	T = Translations;
	SimUtilityService = SimUtilityService;
	ScenarioRecordingState = ScenarioRecordingState;

	@Input() markerSetId: string;
	markerSet: Markerset;
	@Input() scenarioRecording: ScenarioRecording;
	@Input() markerSetPaneShowing: boolean = true;
	@Input() listenForFKeys: boolean;
	addMarker = output<Icon>();

	constructor(
		private _simMarkerSetService: SimMarkersetService,
		private _changeDetector: ChangeDetectorRef,
		private _NotificationService: NotificationService,
		private translate: TranslateService,
	) {}

	public ngOnInit() {}

	public isDurationActive(icon: Icon) {
		if (icon.isEnduring && (this.scenarioRecording?.markers ?? []).length > 0) {
			const durationMarkerCount = Enumerable.from(this.scenarioRecording.markers)
				.where((marker) => marker.icon?.id === icon.id)
				.count();

			return durationMarkerCount % 2 === 1;
		} else {
			return false;
		}
	}

	@HostListener("window:keydown", ["$event"])
	keyEvent(event: KeyboardEvent) {
		if (!(event.key.startsWith("F") && event.key !== "F" && this.listenForFKeys)) {
			return;
		}
		if (event.repeat) {
			event.preventDefault();
			return;
		}

		let functionKeyNumber = parseInt(event.key.substring(1));
		if (isNaN(functionKeyNumber)) {
			return;
		}

		if (!SimUtilityService.isInElectron() && functionKeyNumber > 3) {
			return;
		}

		event.preventDefault();
		if (this.scenarioRecording?.state === ScenarioRecordingState.Prepared) {
			this._NotificationService.notifyInfo(this.translate.instant(this.T.BOOKMARKS_CAN_ONLY_BE_SET_DURING_RECORDING));
		} else if (!this.markerSetPaneShowing) {
			this._NotificationService.notifyInfo(this.translate.instant(this.T.TOGGLE_MARKER_SET_PANE_FIRST_MSG));
		} else {
			(document.activeElement as HTMLElement).blur();
			this.addMarker.emit(this.markerSet?.icons[functionKeyNumber - 1]);
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes["scenarioRecording"]) {
			const previousScenarioRecording = changes["scenarioRecording"]?.previousValue as ScenarioRecording;
			if (
				previousScenarioRecording?.id !== this.scenarioRecording?.id ||
				previousScenarioRecording?.scenario?.markersetId !== this.scenarioRecording?.scenario?.markersetId
			) {
				// scenario may be null in the recording archive
				if (this.scenarioRecording?.scenario?.markersetId) {
					this._simMarkerSetService.getMarkersetById(this.scenarioRecording.scenario.markersetId).then((markerSetRes) => {
						this.markerSet = markerSetRes;
						this._changeDetector.markForCheck();
					});
				}
			}
		}

		if (changes["markerSetId"]) {
			if (changes["markerSetId"]?.previousValue !== this.markerSetId) {
				this._simMarkerSetService.getMarkersetById(this.markerSetId).then((markerSetRes) => {
					this.markerSet = markerSetRes;
					this._changeDetector.markForCheck();
				});
			}
		}
	}

	disableFilterForIcon(iconName: string) {
		return ICONS_WITHOUT_FILTER.some((value) => value === iconName);
	}

	protected readonly TrackByMethods = TrackByMethods;
}
